import { Component, ElementRef, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { takeUntil } from "rxjs/operators";
import { UnsubscribeComponent } from "../../generals/Components";
import { FaqEditor } from "../../interfaces/interfaces";
import { ApiService } from "../../services/api.service";

@Component({
    selector: 'app-faqeditor',
    templateUrl: './faqeditor.component.html',
    styleUrls: ['./faqeditor.component.scss']
})
export class FaqEditorComponent extends UnsubscribeComponent {
    faqId: number = null;
    @ViewChild('input') input: ElementRef<HTMLInputElement>;
    faqEditorFormGroup: FormGroup = null;
    dataLoading = false;
    loading = false;

    init(): void {
        this.initFaqEditorFormGroup();
        this.loadData();
    }

    initFaqEditorFormGroup(): void {
        this.faqEditorFormGroup = new FormGroup({
            question: new FormControl('', [Validators.required]),
            answer: new FormControl('', [Validators.required])
        });
    }

    loadData(): void {
        if (this.faqId !== null) {
            this.dataLoading = true;
            this.apiService.getFaq(this.faqId).subscribe(({faqEditor}) => {
                this.fillFaqEditorForm(faqEditor);
                this.dataLoading = false;
            });
        }
    }

    fillFaqEditorForm(faqEditor: FaqEditor): void {
        this.faqEditorFormGroup.get('question').setValue(faqEditor.question);
        this.faqEditorFormGroup.get('answer').setValue(faqEditor.answer);
    }

    save(): void {
        if (this.faqEditorFormGroup.invalid) {
            return;
        }
        this.loading = true;
        const faqEditorFormValue: any = this.faqEditorFormGroup.value;
        if (this.faqId === null) {
            this.apiService.createFaq(faqEditorFormValue).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
                this.ref.close(true);
            }).add(() => {
                this.loading = false;
            });
        } else {
            this.apiService.saveFaq(this.faqId, faqEditorFormValue).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
                this.ref.close(true);
            }).add(() => {
                this.loading = false;
            });
        }
    }

    close(result: boolean = false): void {
        this.ref.close(result);
    }

    ngAfterViewInit(): void {
        this.input.nativeElement.focus();
    }

    constructor(
        private apiService: ApiService,
        private ref: DynamicDialogRef,
        private config: DynamicDialogConfig
    ) {
        super();
        this.faqId = this.config.data.faqId;
        this.init();
    }
}